import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Sınıf birleştirici.
 *
 * `twMerge` çakışan Tailwind sınıflarında SONRAKİNİ kazandırır. Bu, bileşenin
 * varsayılan sınıfını çağıranın ezebilmesi için gerekli: `<Dugme
 * className="w-full">` yazıldığında bileşenin kendi genişliği değil çağıranın
 * verdiği geçerli olur. Düz birleştirme yapılırsa iki sınıf da CSS'e girer ve
 * hangisinin kazandığı dosya sırasına bağlı kalır — sessiz hata kaynağı.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
